<template>
  <div class="content">
    <ly-header></ly-header>
    <div class="top">
      <ul class="left">
        <li>运行数量：250</li>
        <li>故障数量：0</li>
      </ul>
      <div class="center">
        <date-picker v-model="date1" valueType="format" appendToBody></date-picker>
        <span class="txt">至</span>
        <date-picker v-model="date2" valueType="format" appendToBody></date-picker>
        <button class="btn-cx" @click="HandleGetData()">查询</button>
      </div>
      <div class="right">
        <router-link to="/home/details" tag="div" class="btn">设备生命周期</router-link>
      </div>
    </div>
    <div class="theme-green bottom">
      <div class="bottom_l">
        <div class="titles">
          <img src="../assets/img/title-sjfx.png" alt />
        </div>
        <div style="height:calc(100% - 40px);">
          <!-- <device-maintain
            :sjtjLists="sjtjList"
            :gzsjhzLists="gzsjhzList"
            :gzhzLists="gzhzList"
            :charts8Data="sbfhData"
          ></device-maintain> -->
          <device-maintain
          :sjtjLists="sjtjList"
          :gzsjhzLists="gzsjhzList"
          :gzhzLists="gzhzList"
        ></device-maintain>
        </div>
      </div>
      <div class="bottom-r">
        <div class="titles">
          <img src="../assets/img/title-wbtj.png" alt />
        </div>
        <div class="navs">
          <div>
            <!-- 数据分析 -->
            <device-detail :StartDates="date1" :EndDates="date2" ref="child"></device-detail>
          </div>
          <div class="navs2">
            <div>
              <img src="../assets/img/wbtj-title.png" alt style="height:50px" />
              <device-wb></device-wb>
            </div>
            <div>
              <img src="../assets/img/jkzs-title.png" alt style="height:50px" />
              <device-jkzs></device-jkzs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 设备维保-内容
import LyHeader from "./common/Header";
import DeviceMaintain from "../device/DeviceMaintain";

// 故障保养清单
import DeviceDetail from "../device/DeviceMaintainRecord";
//设备维保
import DeviceWb from "./home/echarts1";
//设备健康指数
import DeviceJkzs from "./home/echarts2";

import DatePicker from "vue2-datepicker"; //时间选择

export default {
  name: "Home",
  data() {
    let todayTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000; //今天0点时间戳秒
    return {
      date1: this.$formatDateTime(todayTime - 3600 * 24 * 30, "yyyy-MM-dd"),
      date2: this.$formatDateTime(null, "yyyy-MM-dd"),
      sjtjList: [],
      gzhzList: [],
      gzsjhzList: [],
      itemList: [],
      sbfhData: []
    };
  },
  components: {
    LyHeader,
    DatePicker,
    DeviceMaintain,
    DeviceDetail,
    DeviceWb,
    DeviceJkzs
  },
  mounted() {
    // window.gbfc_resetData = this.resetData;
    this.resetData();
  },
  methods: {
    
    // 默认请求数据
    resetData() {
      if (window.setDate) {
        window.setDate(
          JSON.stringify({ StartDate: this.StartDate, EndDate: this.EndDate })
        );
      }
      this.getSjtjList();
      this.getGzhzList();
      this.getGzsjhzList();
      this.getSbfhList();
    },
    // 按时间获取数据
    HandleGetData() {
      this.resetData();
      this.$refs.child.getItemList1()
    },
    getSjtjList() {
      //时间统计
      let self = this;
      let totalData = [];
      let recentData = [];
      let sjtjList = [];
      this.$handleRequest(
        window.ApiHost2 +
          "/InteractAPI/CalcuTotalDuration_FieldStutas/" +
          window.PYKScadaCode1 +
          "/自动/-1",
        {},
        "get",
        function(res) {
          //success

          totalData = res;
          self.$handleRequest(
            window.ApiHost2 +
              "/InteractAPI/CalcuTotalDuration_FieldStutas/" +
              window.PYKScadaCode1 +
              "/自动/1",
            {},
            "get",
            function(res) {
              //success
              recentData = res;

              console.log("--recentData--", res, totalData, recentData);
              totalData.forEach(function(t, ti) {
                recentData.forEach(function(r, ri) {
                  if (t.Field == r.Field) {
                    let tmp = {
                      field: t.Field,
                      lists: [
                        {
                          label: "历史运行总时长",
                          count: t.TotalDuration
                        },
                        {
                          label: "最近一次运行总时长",
                          count: r.TotalDuration
                        }
                      ]
                    };
                    sjtjList.push(tmp);
                  }
                });
              });
              self.sjtjList = sjtjList;
              self.setOptionsSjtj();
            },
            function(res) {
              //fail
            }
          );
        },
        function(res) {
          //fail
        }
      );
    },
    getGzhzList() {
      //故障次数汇总
      let self = this;
      let todayTime =
        new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000; //今天0点时间戳毫秒
      let startTime = this.$formatDateTime(
        todayTime - 3600 * 24,
        "yyyy-MM-dd hh:mm:ss"
      );
      let endTime = this.$formatDateTime(todayTime, "yyyy-MM-dd hh:mm:ss");

      if (this.tabKey == "日") {
        //
      } else if (this.tabKey == "周") {
        startTime = this.$formatDateTime(
          todayTime - 3600 * 24 * 7,
          "yyyy-MM-dd hh:mm:ss"
        );
      } else if (this.tabKey == "月") {
        startTime = this.$formatDateTime(
          todayTime - 3600 * 24 * 30,
          "yyyy-MM-dd hh:mm:ss"
        );
      }
      // console.log("--", startTime, endTime);
      let url =
        "/InteractAPI/FailureDistribution_Stn_Times/" +
        this.date1 +
        "/" +
        this.date2;
      this.$handleRequest(
        window.ApiHost2 + url,
        {},
        "get",
        function(res) {
          //success
          self.gzhzList = res;
        },
        function(res) {
          //fail
          console.log("fail", res);
        }
      );
    },
    getGzsjhzList() {
      //故障时间汇总
      let self = this;
      let todayTime =
        new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000; //今天0点时间戳毫秒
      let startTime = this.$formatDateTime(
        todayTime - 3600 * 24,
        "yyyy-MM-dd hh:mm:ss"
      );
      let endTime = this.$formatDateTime(todayTime, "yyyy-MM-dd hh:mm:ss");

      if (this.tabKey == "日") {
        //
      } else if (this.tabKey == "周") {
        startTime = this.$formatDateTime(
          todayTime - 3600 * 24 * 7,
          "yyyy-MM-dd hh:mm:ss"
        );
      } else if (this.tabKey == "月") {
        startTime = this.$formatDateTime(
          todayTime - 3600 * 24 * 30,
          "yyyy-MM-dd hh:mm:ss"
        );
      }
      let url =
        "/InteractAPI/Distribution_AE_Stn_Duration/" +
        window.PYKScadaCode +
        "/" +
        this.date1 +
        "/" +
        this.date2 +
        "/0";
      this.$handleRequest(
        window.ApiHost2 + url,
        {},
        "get",
        function(res) {
          //success
          self.gzsjhzList = res;
        },
        function(res) {
          //fail
          console.log("fail", res);
        }
      );
    },
    getSbfhList() {
      //设备负荷
      var _this = this;
      this.$handleRequest(
        window.ApiHost1 + "/api/DataStatistical/Piler_Work_Ratio",
        {
          starttime: this.date1,
          endtime: this.date2,
          WareHouseCode: window.PYKWareHouseCode
        },
        "post",
        function(res) {
          //success
          console.log(res)
          _this.sbfhData = res.retData;
        },
        function(res) {
          //fail
          console.log("设备负荷请求失败");
        }
      );
    }
  }
};
</script>

<style scoped>
.content {
  width: 1918px;
  height: 853px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  background-color: #348975;
}
.top {
  margin-top: 113px;
  padding: 0 30px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  background-color: #fff;
}
.left {
  display: flex;
  justify-content: start;
  flex-direction: row;
}
.left li {
  margin-left: 12px;
}
.right .btn {
  width: 130px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  color: #fff;
  background-color: #2eb58a;
}
.btn-cx {
  width: 80px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: #2eb58a;
}
.bottom {
  padding: 10px 10px;
  height: calc(100% - 174px);
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.bottom > div {
  width: calc(50% - 5px);
  height: 100%;
  border: 1px solid #fff;
  box-sizing: border-box;
  background-color: #fff;
}
.titles {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.nav {
  height: calc(100% - 40px);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.navs {
  height: calc(100% - 40px);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.navs > div:first-child {
  height: 60%;
  width: 100%;
}
.navs > div:last-child {
  height: 40%;
  width: 100%;
}
.navs2 {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.navs2 > div {
  width: 50%;
  height: 100%;
  position: relative;
}
.navs2 > div:first-child {
  border-right: 1px solid #cae8ff;
  box-sizing: border-box;
}
.navs2 > div > img {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
  width: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/xiayan/home/Home.vue